import { render } from "./InterconsultaOrigenForm.vue?vue&type=template&id=47287c83&scoped=true"
import script from "./InterconsultaOrigenForm.vue?vue&type=script&lang=js"
export * from "./InterconsultaOrigenForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=47287c83&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47287c83"]])

export default __exports__